$(document).ready(function () {
  // Delete review
  $('.btn-delete-rivew').on('click', function(e){
    const ratingId = $(this).data('id');
    if(ratingId) deleteReviewModal(ratingId);
  });

  function deleteReviewModal(ratingId) {

    var html =  '<div id="dynamicModal" class="modal fade" tabindex="-1" data-keyboard="false" data-backdrop="static" role="dialog" aria-labelledby="confirm-modal" aria-hidden="true">';
    html += '<div class="modal-dialog">';
    html += '<div class="modal-content">';
    html += '<div class="modal-body">';
    html += '<label>Are you POSITIVE you want to PERMANENTLY delete this review? If so, please specify why:</label>'
    html += '<textarea name="review" maxlength="1000" id="restaurant-review" class="text-review form-control" rows="5" placeholder="Please specify a reason why you delete this review?"></textarea>';
    html += '</div>';
    html += '<div class="text-center" style="padding: 0 15px 15px;">';
    html += '<button type="button" class="btn btn-green" data-dismiss="modal">Cancel</button>';
    html += '<button type="button" class="btn btn-danger confirm-delete-review">Delete</button>';
    html += '</div>';  // content
    html += '</div>';  // dialog
    html += '</div>';  // modalWindow
    $('body').append(html);
    $("#dynamicModal").modal();
    $("#dynamicModal").modal('show');

    $('.confirm-delete-review').on('click', function(){
      const reasonText = $.trim($("#dynamicModal").find('textarea[name="review"]').val());
      if(reasonText) {
        const callback = function(res) {
          $("#dynamicModal").modal('hide');
          if (res.code == 0) {
            Swal.fire({
                title: "Success",
                text: res.message,
                icon: "success",
            });
          
            $('#item-review-'+ratingId).remove();
          } else {
            Swal.fire({
                title: "Oops",
                text: res.message,
                icon: "error",
            });
          }
        }
        deleteReview(ratingId, reasonText, callback);
      } else {
        $("#dynamicModal").find('textarea[name="review"]').focus();
      }
    })

    $('#dynamicModal').on('hidden.bs.modal', function (e) {
        $(this).remove();
    });
  }

  function deleteReview(ratingId, reasonText, cb) {
    $.ajax({
      url: '/ratings/delete',
      method: 'POST',
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify({ratingId: ratingId, reasonText: reasonText }),
      dataType: 'json',
      error: function (err) {
        $("#dynamicModal").modal('hide');
        Swal.fire({
            title: "Oops",
            text: "Please try again and reload the page once!",
            icon: "error",
        });
      }
    }).then(function (res) {
      cb(res)
    })
  }
});
